import { CameraBurstIcon } from './CameraBurstIcon';

/**
 * author: Google
 * id 4FCD7DBE-6B4C-41DB-BDD8-40ED820EC7F1
 * name camera-burst
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/camera-burst.svg
 * tags
 * - Photography 
 */
export const BurstModeIcon = CameraBurstIcon;
export default BurstModeIcon